import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"pencil\"><path d=\"M0 14.252v3.75h3.75l11.06-11.06-3.75-3.75L0 14.252zm17.71-10.21a.996.996 0 0 0 0-1.41L15.37.293a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol